import { FormButtons, ResetButton, SubmitButton } from "../Interfaces/FormProps";

export const isResetButton = (button: FormButtons): button is ResetButton => {
  return button.type === "reset";
};

export const isSubmitButton = (button: FormButtons): button is SubmitButton => {
  return button.type === "submit";
};
